import { GROUP_PREFIX, RESERVATION_PREFIX } from './constants';
import { GroupsAndReservationsDialogFormKeys, GroupsAndReservationsDialogFormValues } from './schema';
import { GroupsAndReservationsDialogDefaultValues } from './types';

export const useDefaultFormValues = (
    defaultValues?: GroupsAndReservationsDialogDefaultValues
): GroupsAndReservationsDialogFormValues | undefined => {
    return {
        [GroupsAndReservationsDialogFormKeys.groupsAndReservations]: [
            ...(defaultValues?.reservationGroupIds ?? []).map((id) => `${GROUP_PREFIX}${id}`),
            ...(defaultValues?.reservationIds ?? []).map((id) => `${RESERVATION_PREFIX}${id}`),
        ],
        [GroupsAndReservationsDialogFormKeys.reservationsWithGroupChecked]: [],
    };
};
